import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "pilotos",
    "piloto",
    "PilotoForm",
    "/pilotos",
);

export default handleActions(reducers, initialState);
